import React, { useState, useEffect } from 'react';
import Button from 'react-bootstrap/Button';
import Row from 'react-bootstrap/Row';
import Col from 'react-bootstrap/Col';
import Container from 'react-bootstrap/Container';
import PropTypes from 'prop-types';
import TeacherProfile from '../profilePage/TeacherPage';
import { connect } from 'react-redux';
import { request } from '../../redux/actions/genericAction';
import { TitleBar, IconSelected, evenRowColor } from '../common/theme';
import { toArray } from '../../Utils';
import { sort, isObjectEmpty } from '../../Utils';
import { debounce } from 'lodash';
import { getCreateUserStatus, properName } from '../../ApiHelper';
import DialogClassList from '../common/DialogClassList';
import Spinner from '../common/generic/Spinner';
import ErrorDialog from '../common/ErrorDialog';
import Alert from 'react-bootstrap/Alert';

const ContainerComp = ({pageState, isAdmin}) =>{ 
    return <>{pageState.classesData && <div><StudentTableComp pageState={pageState} isAdmin={isAdmin}/></div>}</>;
};

ContainerComp.propTypes = {
    pageState: PropTypes.object,
    isAdmin: PropTypes.bool
};

const StudentTableComp = ( {pageState, isAdmin}) => {

    const [studentData, setStudentData] = useState([]);
    const [editMode, setEditMode] = useState(false);
    const [canSave, setCanSave] = useState(false);
    const {showAddUserComp, showTeacherProfileComp} = pageState;
    const [disableButtons, setDisableButtons] = useState(true);
    const [isSavingChanges, setIsSavingChanges] = useState(false);
    const [dialog, setDialog] = useState({show:false});
    const [dialogError, setDialogError] = useState({show:false});
    const [moveClass, setMoveClass] = useState({});

    useEffect(()=>{
        setDisableButtons(studentData.reduce((acc,e)=>{if(e.isSelected) acc=false; return acc;},true));
    },[studentData]);
    
    const componentState ={
        studentData, setStudentData,
        editMode, setEditMode,
        canSave, setCanSave
    };
 
    const titleRow = <Row style={{fontWeight:'bold'}}>
        <Col style={{textAlign: 'left'}} xs='6'>Student Name</Col>
        <Col style={{textAlign: 'left'}} xs='3'>Username</Col>
        <Col style={{textAlign: 'left'}} xs='3'>Password</Col>
    </Row>;
     const titleRowLTI = <Row style={{fontWeight:'bold'}}>
        <Col style={{textAlign: 'left'}} xs='6'>Student Name</Col>
        <Col style={{textAlign: 'left'}} xs='6'>Username</Col>
    </Row>;
    useEffect(()=>{
        if(!pageState.showStudentTableComp.classInfo || !pageState.showStudentTableComp.classInfo.ClassID) return;
        let getStudentsForClassQuery={
            params: pageState.showStudentTableComp.classInfo.ClassID,
            func:'getStudentsForClass'            
        };
        pageState.request(getStudentsForClassQuery);      
    },[pageState.showStudentTableComp]);

    useEffect(()=>{

        if(pageState.database['saveStudent'] && pageState.database['saveStudent'].isLoaded){
            pageState.deleteThis('saveStudent');
            pageState.deleteThis('getStudentsForClass');

            let getAllStudentsQuery = {
                params: pageState.showStudentTableComp.classInfo.ClassID,
                func:'getStudentsForClass',
              };
              pageState.request(getAllStudentsQuery);
        }
    });

    useEffect(()=>{
        if(pageState.pageType!=='Student') return;
        const isLTIMode=()=>(sessionStorage.getItem('LTIMode') !== null);
        if(pageState.database['getStudentsForClass'] && pageState.database['getStudentsForClass'].isLoaded 
            && pageState.database['getStudentsForClass'].data && toArray(pageState.database['getStudentsForClass'].data).length===0 
            && !pageState.showBulkStudentComp && !pageState.showClassTableComp && !pageState.showLinkStudentsComp){
            if(!isLTIMode() && !pageState.showAddUserComp){ // only show add Student Comp if there are no students on the student page
                pageState.showAddUserScreen('Student');
            }
            return;
        } 

    },[pageState.database['getStudentsForClass']]);

    // reload and sort students
    useEffect(()=>{   
        if(pageState.database['getStudentsForClass'] && pageState.database['getStudentsForClass'].isLoaded){
            let arrayData = Object.keys(pageState.database['getStudentsForClass'].data).map((key) => pageState.database['getStudentsForClass'].data[key])
                .sort((a,b) => (a.Name.toUpperCase() > b.Name.toUpperCase()) ? 1 : (a.Name.toUpperCase() < b.Name.toUpperCase() ? -1 : 0))
                .map(e=>{return {...e, isSelected:false};});
            setStudentData(arrayData);  
        }
    },[pageState.database['getStudentsForClass']]);

    const saveClicked = () =>{
        let saveQuery = [];
        Object.keys(pageState.studentEditsForSave).map((key, i) => {
            let mergedChanges = {...pageState.studentEditsForSave[key].original, ...pageState.studentEditsForSave[key].changed};
            let {id, studentL, studentP, studentN} = mergedChanges;

            if(pageState.studentEditsForSave[key].changed){
                studentL= (pageState.studentEditsForSave[key].changed.studentL)?pageState.studentEditsForSave[key].changed.studentL:studentL;
                studentP= (pageState.studentEditsForSave[key].changed.studentP)?pageState.studentEditsForSave[key].changed.studentP:studentP;
                studentN= (pageState.studentEditsForSave[key].changed.studentN)?pageState.studentEditsForSave[key].changed.studentN:studentN;
            }

            let prevQuery = (i!=0) ? saveQuery[i-1] : 'undefinded';
            let classID = pageState.showStudentTableComp.classInfo.ClassID;

            let query = {
                params:`${id}~${classID}~${studentN.trim()}~${studentL.trim()}~${studentP.trim()}~2`,
                func:'saveStudent'   
            };
            if(prevQuery !== 'undefinded')
                query.nextRequest = prevQuery;
            saveQuery.push(query);
        });

        setEditMode(false); 
        setCanSave(false); 
        pageState.setStudentEditsForSave({});
        pageState.request(saveQuery[saveQuery.length-1]); 

    };

    const printPasswords=()=>{
        var w = window.open();

        if(!w || !w.document.write || w.closed || typeof w.closed=='undefined') 
        { 
            setDialogError({title:'Problem showing reports', text:'Please turn off your pop-up blocker to see the student password list', show:true});
            return;
        }

        var schoolURLNum = pageState.database['getCustomer'].data['URL_NUM'];
        var header = `<html><head><title>Use Browser to Print</title><style>body {font-family: Arial, Helvetica, sans-serif;}</style></head><body><center><H3> Student passwords for ${pageState.showStudentTableComp.classInfo.Classname} </H3><H4>SchoolID: ${schoolURLNum}</H4><H4>online.essentialskills.com</H4></center>`;
        var html = '<table style="margin: 0px auto;" width="600px"><tr><th align="left">Name</th><th align="left">Username</th><th align="left">Password</th></tr>';
        
        studentData.forEach(studentRec => { 
            let pass=(studentRec.Password)?studentRec.Password:''; 
            html += `<tr><td>${studentRec.Name}</td><td>${properName(studentRec.CompareName)}</td><td>${pass}</td></tr>`;
        });
        var footer = '</body></html>';
        w.document.write(header+html+footer);
        w.document.close();
    };

    const printPasswordCards=()=>{
        var w = window.open();

        if(!w || !w.document.write || w.closed || typeof w.closed=='undefined') 
        { 
            setDialogError({title:'Problem showing reports', text:'Please turn off your pop-up blocker to see the student password list', show:true});
            return;
        }
        var schoolURLNum = pageState.database['getCustomer'].data['URL_NUM'];
        var header = '<html><head><title>Use Browser to Print</title><link rel="stylesheet" type="text/css" href="https://dashboard.essentialskills.com/assets/printpage.css"></head><body>';

        var html = '';
        let studentData_ = [...studentData];
        if(studentData_.length %3 ==1){
            studentData_.push({Password:'',Name:'',CompareName:''});
            studentData_.push({Password:'',Name:'',CompareName:''});
        }
        if(studentData_.length %3 ==2){
            studentData_.push({Password:'',Name:'',CompareName:''});
        }
        studentData_.forEach((studentRec, i) => { 
            let pass=(studentRec.Password)?studentRec.Password:''; 
            if(i%3==0 && i !==0) html += '</tr></table>';
            if(i%15==0 && i !==0) html += '<div class="pagebreak"> </div>';
            let borderClass = '';
            let lastRow = (i + 3 > studentData.length);
            let count = i%15;
            if(count==12 || lastRow){
                borderClass='class="noBottom"';
            }
            if(i%3==0) html += `<table ${borderClass} width="100%"><tr>`;

            html += '<td><div class="cardBackground cardSize">';
            html += `<center><strong>${studentRec.Name}</strong><br><div class="smallfont" >essentialskillsonline.com</div></center>`;
            html += `<div class="textPlacement">
                <strong>SchoolID:</strong> ${schoolURLNum}</br>
                <strong>Class:</strong> ${pageState.showStudentTableComp.classInfo.Classname}</br>
                <strong>Username:</strong> ${properName(studentRec.CompareName)}</br>
                <strong>Password:</strong> ${pass}</div>`;
            html += '</div></td>';
        });        

        html += '</tr></table>';
        var footer = '</body></html>';
        w.document.write(header+html+footer);
        w.document.close();
    };    

    const isSaving = () => (pageState.database['saveStudent'] && !pageState.database['saveStudent'].isLoaded);
    const isLoading = () => (pageState.database['getStudentsForClass'] && !pageState.database['getStudentsForClass'].isLoaded);
    const displayCreateUser = () => pageState.showAddUserScreen('Student');
    const displayLinkUser = () => pageState.showLinkStudentsScreen();
    const displayTeacherProfile = () => pageState.showProfileScreen();

    const deleteStudents=()=>{
        if(!window.confirm('Are you sure you want to delete the selected student(s)'))
            return;

        let classID = pageState.showStudentTableComp.classInfo.ClassID;
        let schoolID = pageState.database['getCustomer'].data['ID'];
        let saveChanges = [];

        studentData.forEach(studRec=>{
            if(studRec.isSelected){
                let studID = studRec.StudentID;
                if(studRec.ClassID+'' !== classID+'')
                    saveChanges.push({debug:'Remove Attached Student', func:'removeAttachStudent', params: `${studID}`});
                else{
                    saveChanges.push({debug:'Delete Student', func:'deleteStudent', params: `${studID}~${schoolID}`});
                    saveChanges.push({debug:'Backup Student', func:'backupStudent', params: `${studID}`});
                }
            }
        });

        // create a link list of save changes querys for saving to the database
        if(saveChanges.length > 0){
            setIsSavingChanges(true);
            let counter = 1;
            saveChanges = saveChanges.map((query,i)=>{
                let prevQuery = (i!=0) ? saveChanges[i-1] : 'undefinded';
                if(prevQuery !== 'undefinded'){
                    counter++;
                    query.nextRequest = prevQuery;
                }
                return query;
            });
            let saveChainedChanges = saveChanges[saveChanges.length-1];
            saveChainedChanges.numQueries = counter;

            // tell the customer record that some students were deleted
            counter = counter/2;
            let currentNumStudents = parseInt(pageState.database['getCustomer'].data['NumStudents']);
            currentNumStudents = (currentNumStudents - counter < 0)?0:(currentNumStudents - counter);            
            pageState.database['getCustomer'].data['NumStudents'] = currentNumStudents+''; 

            // pass the link list of saved changes into the database
            pageState.request(saveChainedChanges); 
        }
    };

    // move students
    useEffect(()=>{
        if(!pageState.database['moveStudentsClass'] || !pageState.database['moveStudentsClass'].isLoaded) return;
        let moveToClassStudent = toArray(pageState.database['moveStudentsClass'].data);
        let classID = pageState.showStudentTableComp.classInfo.ClassID;
        let saveChanges = [];
        let hasTakenStudent = false;

        studentData.forEach(studRec=>{
            if(studRec.isSelected){
                let studID = studRec.StudentID;

                let hasTakenName = moveToClassStudent.reduce((acc,otherStudRec)=>{if(otherStudRec.Name.toUpperCase() == studRec.Name.toUpperCase())acc=true;return acc;},false);
                let hasTakenLogin = moveToClassStudent.reduce((acc,otherStudRec)=>{if(otherStudRec.CompareName.toUpperCase() == studRec.CompareName.toUpperCase())acc=true;return acc;},false);

                if(hasTakenName || hasTakenLogin) hasTakenStudent = true;

                if(!hasTakenName && !hasTakenLogin){
                    if(studRec.ClassID !== classID)
                        saveChanges.push({debug:'Move Attached Student', func:'attachStudent', params: `${studID}~${moveClass['ClassID']}~${studRec.attachName}`});
                    else{
                        saveChanges.push({debug:'Move Student', func:'moveStudent', params: `${studID}~${moveClass['ClassID']}~${moveClass['Classname']}`});
                    }
                }
            }
        });

        if(hasTakenStudent){
            window.alert('Warning: One or more students will not be moved because their name or username is already taken.');
        }

        // create a link list of save changes querys for saving to the database
        if(saveChanges.length > 0){
            setIsSavingChanges(true);
            let counter = 1;
            saveChanges = saveChanges.map((query,i)=>{
                let prevQuery = (i!=0) ? saveChanges[i-1] : 'undefinded';
                if(prevQuery !== 'undefinded'){
                    counter++;
                    query.nextRequest = prevQuery;
                }
                return query;
            });
            let saveChainedChanges = saveChanges[saveChanges.length-1];
            saveChainedChanges.numQueries = counter;

            // pass the link list of saved changes into the database
            pageState.request(saveChainedChanges); 
        }
    },[pageState.database['moveStudentsClass']]);


    const processSelectedClass=(moveClass)=>{
        let getStudentsForClassQuery = {
            params: moveClass['ClassID'],
            func:'getStudentsForClass',
            altName: 'moveStudentsClass',
          };    
        setMoveClass(moveClass);
        pageState.request(getStudentsForClassQuery);        
    };

    const moveStudents=()=>{
        setDialog({title:'Select a class to move the selected students too.', classes:toArray(pageState.database['getAllClasses'].data), show:true, processSelectedClass});
    };

    useEffect(()=>{
        if(isSavingChanges){
            if(pageState.database.queryCount == 0){
                setIsSavingChanges(false);
                pageState.deleteThis('getStudentsForClass');

                let getAllStudentsQuery = {
                    params: pageState.showStudentTableComp.classInfo.ClassID,
                    func:'getStudentsForClass',
                  };
                  pageState.request(getAllStudentsQuery);            
            }
        }
    },[pageState.database.queryCount]);

    const selectAll = () => {        
        let nextState = [...componentState.studentData];
        nextState = nextState.map(el=>{return{...el, isSelected:true};});
        componentState.setStudentData(nextState);    
    };

    const unselectAll = () => {        
        let nextState = [...componentState.studentData];
        nextState = nextState.map(el=>{return{...el, isSelected:false};});
        componentState.setStudentData(nextState);    
    };

    const cancelEdit=()=>{
        setEditMode(false); 
        setCanSave(false); 
        pageState.setStudentEditsForSave({});
    };

    const isLTIMode=()=>(sessionStorage.getItem('LTIMode') !== null);

    if(!pageState.showStudentTableComp.display && editMode)
        cancelEdit();

    return ((!pageState.showStudentTableComp.display)?<></>:<>
        {(isSavingChanges || isSaving() || isLoading())?
        <> <Spinner/> <center><h1>Processing...({pageState.database['queryCount']})</h1></center></>:<> 
        <Container>
            {isAdmin && <>
                {!showTeacherProfileComp && <>
                    <Button variant="success" onClick={()=>displayTeacherProfile()}>Edit</Button>
                    <h3 style={{display:'inline'}} > {pageState.showStudentTableComp.classInfo.Classname} </h3><br/>
                </>}
                <br/>
            </>}       

            {!showAddUserComp && <Row>

                {!isLTIMode() && (
                    <>
                        <Col xs={3}>
                            <Button variant="success" onClick={displayCreateUser}> Add Student(s) </Button>
                        </Col>
                        <Col xs={9}>
                        <Alert variant="primary">
                            <strong>Note:</strong> Click 'Edit' to update usernames or
                            passwords, or select a student and click 'Delete' to remove them.
                        </Alert>
                        </Col>
                    </>
                )}

                {/* !isLTIMode() && <><Col xs='3'><Button variant="success" onClick={()=>displayCreateUser()} >Add Student(s)</Button> &nbsp;</Col></>}

                {componentState.studentData.reduce((acc,studRec)=>{
                    if(studRec.attachID && studRec.attachID === pageState.showStudentTableComp.classInfo.ClassID) acc = true;
                    return acc;
                },false) ?
                    <Col xs='9'> <Alert variant='primary'><strong>Note:</strong> Click 'Edit' to update usernames or passwords, or select a student and click 'Delete' to remove them.</Alert></Col> : <><Col xs='9'> <Alert variant='primary'><strong>Note:</strong> Click 'Edit' to update usernames or passwords, or select a student and click 'Delete' to remove them.</Alert></Col></>
                */}
                {/* {isAdmin && <><Button variant="success" onClick={()=>displayLinkUser()} >Link Students from another class</Button> &nbsp;</>} */}
                {/* <Button variant="danger" onClick={()=>displayCreateUser()} >Wipe Student(s)</Button> &nbsp; */}
                {/* <br/>&nbsp; */}
            </Row> }
            
            <TitleBar>
                <Col  style={{textAlign: 'left', color: 'white' }} xs='4'><h3>Students</h3></Col>
                
                <Col  style={{textAlign: 'left', color: 'white' }} xs='8'>
                {!isLTIMode() &&
                    <span className={'pull-right'}>                    
                        {!(editMode) && <><Button onClick={printPasswordCards} variant="warning">ID Cards</Button>&nbsp;<Button onClick={printPasswords} variant="warning">Password List</Button> &nbsp;</>}
                        {(!(editMode)) && isAdmin && <><Button variant="info" onClick={moveStudents} disabled={disableButtons}>Move</Button> &nbsp;</>}
                        {(!(editMode)) &&  <><Button variant="danger" onClick={deleteStudents} disabled={disableButtons}>Delete</Button> &nbsp;</>}
                        {!(editMode) && 
                        <>
                            {(!disableButtons)
                            ?<><Button onClick={()=>setEditMode(true)} variant="success" disabled={!disableButtons} data-toggle={'Unselect all students before editing'} title={'Unselect all students before editing'}>Edit</Button> &nbsp;</>
                            :<><Button onClick={()=>setEditMode(true)} variant="success" >Edit</Button> &nbsp;</>
                            }
                        </>}
                        {(editMode) && <> <Button onClick={saveClicked} variant="success" disabled={!canSave} >Save</Button> &nbsp; </>}
                        {(editMode) && <> <Button onClick={()=>cancelEdit()} variant="danger" >Cancel</Button> &nbsp; </>}
                    </span>
                }    
                </Col>
            </TitleBar>
        </Container>      
              
        <div style={{overflowY:'scroll', overflowX : 'hidden',height:'300px', padding:'10px', borderBottom: '1px solid #cfcfcf', borderLeft: '1px solid #cfcfcf', borderRight: '1px solid #cfcfcf'}}>
            {!isLTIMode() && titleRow}
            {isLTIMode() && titleRowLTI}
            {studentData.map((studentRec, i) => 
                <StudentRow key={i} index={i} studentState={studentRec} componentState={componentState} pageState={pageState} />
            )}
        </div> 
        {(!isLTIMode() && !(editMode)) && <Col xs={12}><Button onClick={selectAll}>Select All</Button> &nbsp; <Button onClick={unselectAll}>Unselect All</Button></Col>}  
        <DialogClassList dialogState={{dialog, setDialog, classID:pageState.showStudentTableComp.classInfo.ClassID}} />      
        <CheckIfCanSave componentState={componentState} pageState={pageState}/>
    </>}<ErrorDialog dialogState={{dialogError, setDialogError}} /></>
    );
};

const CheckIfCanSave = ({pageState, componentState}) =>{
    const hasCellError=(colName, newState)=>{
        if (typeof newState.changed[colName] === 'undefined') { return false;} 
        if((newState.changed[colName])==='' && colName!=='studentP') return true; // check is the column is empty ''
        if(!(newState.changed[colName])) return false; // check if the column has any change data

        let userItem = newState.changed[colName];
        let takenList = [];        
        
        takenList = (colName === 'studentN') ? componentState.studentData.filter(e=>e.StudentID!==newState.id).map(e=>e.Name) : takenList;
        takenList = (colName === 'studentL') ? componentState.studentData.map(e=>e.CompareName) : takenList;
        
        let status = getCreateUserStatus(colName, userItem, true, takenList);
        if(status.error) return true;

        // attempt to update the changed value to the latest value - doent work perfectly because the for loop of 
        // studentRows iterates in order and the changing of the value can happen later in the iteration        
        if(newState && newState.changed && newState.changed[colName]){
            if(!pageState.studentEditsForSave[newState.id]){
                pageState.studentEditsForSave[newState.id]={};
            }
            if(!pageState.studentEditsForSave[newState.id].changed){
                pageState.studentEditsForSave[newState.id].changed={};
            }
            pageState.studentEditsForSave[newState.id].changed[colName] = newState.changed[colName];
        }
        // dont let teachers save changes with 2 of the same names
        let foundError = false;
        if(colName !=='studentP'){
            Object.keys(pageState.studentEditsForSave).forEach((key) => {
                if(pageState.studentEditsForSave[key].id !== newState.id && pageState.studentEditsForSave[key].changed){
                    if(pageState.studentEditsForSave[key].changed[colName] && pageState.studentEditsForSave[key].changed[colName] === newState.changed[colName]){
                        //console.log(`pageState.studentEditsForSave[${key}]`,pageState.studentEditsForSave[key],`pageState.studentEditsForSave[${key}].changed[${colName}]`,pageState.studentEditsForSave[key].changed[colName],`newState.changed[${colName}]`,newState.changed[colName]);
                        foundError = true;
                    }
                }
            });
        }
        if(foundError) return true;

        return false; 
    };

    // check if you can save        
    const hasError = Object.keys(pageState.studentEditsForSave).reduce((acc, key) => {
        let cell = pageState.studentEditsForSave[key];
        if(cell.changed){
            if(hasCellError('studentN',cell)) {acc=true;};
            if(hasCellError('studentL',cell)) {acc=true;};
            if(hasCellError('studentP',cell)) {acc=true;};
        }
        return acc;
    },false);
    componentState.setCanSave(!hasError);

    return <></>;
};

StudentTableComp.propTypes = {
    data: PropTypes.array,
    pageState: PropTypes.object,
    isAdmin: PropTypes.bool
};

const StudentRow = ({studentState, pageState, componentState, index}) => {
    const isLTIMode=()=>(sessionStorage.getItem('LTIMode') !== null);

    const {StudentID, ClassID, Name, CompareName, isSelected} = studentState;
    const Password=(studentState.Password)?studentState.Password:'';

    // must keep at as != AND NOT !== as sometimes the ClassID is an int and others its a string
    let shouldDisable = pageState.showStudentTableComp.classInfo.ClassID != ClassID; 
    const selectedStyle = (isSelected) ? {backgroundColor:'lightblue'} : (index%2==0)?{background:evenRowColor}:{};
    
    const editRowStyle = {
        margin: '2px', 
        borderBottom: '1px solid #cfcfcf',
    };
    
    const green = '#AFFFAF', red = '#FFAFAF', blue='#AFAFFF', white='#FFFFFF';
    const showError=(colName)=>{
        if(!(StudentID in pageState.studentEditsForSave)) return {backgroundColor: white}; // check if the class is in the change list
        if((pageState.studentEditsForSave[StudentID].changed[colName])==='' && colName!=='studentP') return {backgroundColor:red}; // check is the column is empty ''
        if(!(pageState.studentEditsForSave[StudentID].changed[colName])) return {backgroundColor: white}; // check if the column has any change data

        let userItem = pageState.studentEditsForSave[StudentID].changed[colName];
        let newState_id = pageState.studentEditsForSave[StudentID].id;
        let takenList = [];        
        
        takenList = (colName === 'studentN') ? componentState.studentData.filter(e=>e.StudentID!==newState_id).map(e=>e.Name) : takenList;
        takenList = (colName === 'studentL') ? componentState.studentData.map(e=>e.CompareName) : takenList;
        
        let status = getCreateUserStatus(colName, userItem, true, takenList);
        if(status.error) return  {backgroundColor: red};
        
        let foundError = false;
        if(colName !=='studentP'){
            Object.keys(pageState.studentEditsForSave).forEach((key) => {
                if(pageState.studentEditsForSave[key].id !== StudentID && pageState.studentEditsForSave[key].changed && pageState.studentEditsForSave[key].changed[colName]){
                    if( pageState.studentEditsForSave[key].changed[colName] === pageState.studentEditsForSave[StudentID].changed[colName]){
                        foundError = true;
                    }
                }
            });
        }
        if(foundError) return {backgroundColor: red};

        return {backgroundColor: green}; 
    };

    const handleChange = debounce((text, name) =>{
        let nextState = {...pageState.studentEditsForSave};

        nextState[studentState.StudentID] = {
            original:{
                id:StudentID, studentN: Name, studentL: CompareName, studentP: Password
            },
            id:StudentID, studentN: Name, studentL: CompareName, studentP: Password
        };

        if(pageState.studentEditsForSave[studentState.StudentID] && pageState.studentEditsForSave[studentState.StudentID].changed )
        nextState[studentState.StudentID].changed = {...pageState.studentEditsForSave[studentState.StudentID].changed};
        nextState[studentState.StudentID][name] =  text;

        let changed = {}; // combined all changes per row
        if(nextState[studentState.StudentID].changed)
            changed = {...nextState[studentState.StudentID].changed};
        
        changed[name] = text;
        nextState[studentState.StudentID].changed=changed;

        // check to see if they reverted their changes
        if(changed[name] === nextState[studentState.StudentID].original[name])
            delete changed[name];

        if(isObjectEmpty(changed)) // remove row edit if everything is back to the way it was
            delete nextState[studentState.StudentID];

        pageState.setStudentEditsForSave(nextState);
    },250);

    const toggleSelect = (studID) => {
        let nextState = [...componentState.studentData];
        let studIdx = nextState.findIndex(el => el.StudentID === studID);
        nextState[studIdx].isSelected = !nextState[studIdx].isSelected;
        componentState.setStudentData(nextState);      
    };

    return (
        <>
            {!isLTIMode()&&<>
                {(componentState.editMode && shouldDisable) && <>
                    <Row className={'form-group'} style={editRowStyle}>
                        <Col style={{textAlign: 'left'}} xs='6'> {Name} </Col>
                        <Col style={{textAlign: 'left'}} xs='3'> {CompareName} </Col>
                        <Col style={{textAlign: 'left'}} xs='3'> {Password} </Col>
                </Row>
                </>}  
                {(componentState.editMode && !shouldDisable) && <>
                    <Row className={'form-group'} style={editRowStyle}>
                        <Col style={{textAlign: 'left'}} xs='6'> <input style={showError('studentN')} type="text" className={'form-control'} name={'studentN'} onChange={e => handleChange(e.target.value, e.target.name)} defaultValue={Name}/> </Col>
                        <Col style={{textAlign: 'left'}} xs='3'> <input style={showError('studentL')} type="text" className={'form-control'} name={'studentL'} onChange={e => handleChange(e.target.value, e.target.name)} defaultValue={properName(CompareName)}/> </Col>
                        <Col style={{textAlign: 'left'}} xs='3'> <input style={showError('studentP')} type="text" className={'form-control'} name={'studentP'} onChange={e => handleChange(e.target.value, e.target.name)} defaultValue={Password}/> </Col>
                    </Row>
                </>}  

                {!(componentState.editMode) && <>
                    <Row style={selectedStyle}>
                    {/* <Row style={{ margin: '2px', borderBottom: '1px solid #cfcfcf',}}> */}
                        <Col style={{textAlign: 'left', paddingLeft: '2em', cursor: 'pointer'}} xs='6' onClick={() => toggleSelect(StudentID)} > <IconSelected isSelected={isSelected}/> {Name} </Col>
                        <Col style={{textAlign: 'left'}} xs='3'> {properName(CompareName)} </Col>
                        <Col style={{textAlign: 'left'}} xs='3'> {'*****'} </Col>
                    </Row>
                </>}
            </>}

            {isLTIMode()&&
                <Row style={selectedStyle}>
                    <Col style={{textAlign: 'left', paddingLeft: '2em', cursor: 'pointer'}} xs='6' > {Name} </Col>
                    <Col style={{textAlign: 'left'}} xs='6'> {properName(CompareName)} </Col>
                </Row>
            }
        </>
    );
};

const mapStateToProps = state => {
    return {
        isAdmin: (state.dashboardReducer.login === 'Admin'),
        database: state.genericReducer
    };
};

export default connect(mapStateToProps, {request})(ContainerComp);